// 页面
import home from '../../views/home/store.js';
import poi from '../../views/poi/store.js';
import user from '../../views/user/store.js';
import order from '../../views/order/store.js';


export default {
	home,
	poi,
	user,
	order
};
